import { parseISO, isEqual, format, isSameMonth, isToday } from "date-fns"

function classNames(...classes) {return classes.filter(Boolean).join(' ')}

const TeacherCalendarMonthViewSmall = ({selectedDay, changeSelectedDay, calendarDaysWithEvents, firstDayOfCurrentMonth}) => {
    return (
        <div className="isolate grid w-full grid-cols-7 grid-rows-6 gap-px lg:hidden">
          {Object.keys(calendarDaysWithEvents).map((day, index) => (
            <button
              key={index}
              type="button"
              onClick={() => changeSelectedDay(day, selectedDay.date)}
              className={classNames(
                isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) ? 'bg-white' : 'bg-blue-50',
                (isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) || isToday(parseISO(day, 'yyyy-MM-dd'))) && 'font-semibold',
                isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && 'text-white',
                !isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-indigo-600',
                !isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-gray-900',
                !isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && !isSameMonth(parseISO(day, 'yyyy-MM-dd'), firstDayOfCurrentMonth) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'text-gray-500',
                'flex h-14 flex-col py-2 border-none px-1 hover:bg-gray-100 focus:z-10'
              )}
            >
              <time
                dateTime={day.date}
                className={classNames(
                  isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && 'flex items-center justify-center rounded-lg',
                  isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && isToday(parseISO(day, 'yyyy-MM-dd')) && 'bg-indigo-600 -mt-1',
                  isEqual(parseISO(day, 'yyyy-MM-dd'), parseISO(format(selectedDay.date, 'yyyy-MM-dd'))) && !isToday(parseISO(day, 'yyyy-MM-dd')) && 'bg-purple-500 -mt-1',
                  'ml-auto h-6 w-6 text-xs m-0'
                )}
              >
                {format(parseISO(day, 'd'), 'd')}
              </time>
              <span className="sr-only">{calendarDaysWithEvents[day].events.length} events</span>
              {calendarDaysWithEvents[day].events.length > 0 && (
                <span className="-mx-0.5 mt-auto flex flex-wrap-reverse">
                  {calendarDaysWithEvents[day].events.map((event) => (
                    <span key={event.id} className="mx-0.5 mb-1 h-1.5 w-1.5 rounded-full bg-gray-400" />
                  ))}
                </span>
              )}
            </button>
          ))}
        </div>
    )
}
export default TeacherCalendarMonthViewSmall